import type { LinkedAccount } from "@store/linkedAccountSlice";
import { PublishedEmptyState } from "./PublishedEmptyState";
import { ScheduledEmptyState } from "./ScheduledEmptyState";

export type PublisherTab = "published" | "scheduled";

export interface SocialPublisherEmptyStateProps {
  tab: PublisherTab;
  accounts: LinkedAccount[];
  onPostVideo: () => void;
}

export const SocialPublisherEmptyState = ({ tab, accounts, onPostVideo }: SocialPublisherEmptyStateProps) => {
  if (tab === "published") {
    return <PublishedEmptyState accounts={accounts} onPostVideo={onPostVideo} />;
  }
  return <ScheduledEmptyState />;
};
